import { jsx as _jsx } from "react/jsx-runtime";
import { ServicesOffered } from '../../common';
import styles from '../DealerLocator.module.scss';
export const DealerLocatorServicesOffered = ({ servicesOfferedTitle, store, isStoreLocationOptimizationFlag }) => {
    const { services } = store;
    return (_jsx("div", { className: `d-flex flex-column order-lg-3 mt-3 ${styles['resp-width']}`, children: _jsx(ServicesOffered, { title: servicesOfferedTitle, servicesOffered: services, isStoreLocationOptimizationFlag: isStoreLocationOptimizationFlag }) }));
};
